<template>
  <highlight-card
    :button="{ href: candle.url, label: texts.memorialCandleCta }"
    :fact="{ icon: 'customCandle', text: candle.price || texts.candleChip }"
    :heading="sprintf(texts.memorialCandleHeading, deceasedName)"
    :image="
      candle.image ? { alt: texts.memorialCandleImageAlt, src: candle.image } : null
    "
    :status="candle.price"
    :text="sprintf(texts.memorialCandleDesc, deceasedName)"
  />
</template>

<script lang="ts" setup>
  import { sprintf } from "sprintf-js";
  import type { Candle } from "../../../highlights/cards";
  import { highlightTexts } from "../../../highlights/texts";
  import HighlightCard from "../HighlightCard.vue";

  defineProps<{ candle: Candle; deceasedName: string }>();

  const texts = highlightTexts();
</script>
